export function getDeviceInfo() {
  const ua = navigator.userAgent;

  let deviceName = "Unknown";
  let deviceVersion = "Unknown";
  let browserName = "Unknown";
  let browserVersion = "Unknown";

  // -------- Device (OS) --------
  if (/Windows NT/.test(ua)) {
    deviceName = "Windows";
    const v = ua.match(/Windows NT ([0-9.]+)/)?.[1];
    deviceVersion = v === "10.0" ? "10 / 11" : v;
  } else if (/Android/.test(ua)) {
    deviceName = "Android";
    deviceVersion = ua.match(/Android ([0-9.]+)/)?.[1];
  } else if (/iPhone|iPad|iPod/.test(ua)) {
    deviceName = "iOS";
    deviceVersion = ua.match(/OS ([0-9_]+)/)?.[1]?.replace(/_/g, ".");
  } else if (/Mac OS X/.test(ua)) {
    deviceName = "macOS";
    deviceVersion = ua.match(/Mac OS X ([0-9_]+)/)?.[1]?.replace(/_/g, ".");
  } else if (/Linux/.test(ua)) {
    deviceName = "Linux";
  }

  // -------- Browser --------
  if (/Edg\/(\d+)/.test(ua)) {
    browserName = "Microsoft Edge";
    browserVersion = ua.match(/Edg\/(\d+(\.\d+)?)/)[1];
  } else if (/OPR\/(\d+)/.test(ua)) {
    browserName = "Opera";
    browserVersion = ua.match(/OPR\/(\d+(\.\d+)?)/)[1];
  } else if (/Chrome\/(\d+)/.test(ua)) {
    browserName = "Google Chrome";
    browserVersion = ua.match(/Chrome\/(\d+(\.\d+)?)/)[1];
  } else if (/Firefox\/(\d+)/.test(ua)) {
    browserName = "Mozilla Firefox";
    browserVersion = ua.match(/Firefox\/(\d+(\.\d+)?)/)[1];
  } else if (/Version\/(\d+(\.\d+)?).*Safari/.test(ua)) {
    browserName = "Safari";
    browserVersion = ua.match(/Version\/(\d+(\.\d+)?)/)[1];
  }

  return {
    deviceName,
    deviceVersion,
    browserName,
    browserVersion
  };
}

// console.log(getDeviceInfo());
